export const PACKAGE_VERSION = '1.8.17';
//# sourceMappingURL=constants.js.map